export const SEARCH_TERM_MAX_LENGTH = 1000;
const CHARS_TO_REMOVE = 10;

export const getTrimmedSearchTerm = (term: string): string => {
  if (isSearchTermValid(term)) {
    return term;
  }

  const trimmedTerm = trimText(term);
  return getTrimmedSearchTerm(trimmedTerm);
};

const isSearchTermValid = (term: string): boolean => new Blob([term]).size <= SEARCH_TERM_MAX_LENGTH;

const trimText = (term: string): string => {
  const termCharacters = Array.from(term);

  return termCharacters.slice(0, termCharacters.length - CHARS_TO_REMOVE).join('');
};
